import { getConsumptionPageType, getLogoPosition, getStableShortCode, getUserId, isMobileDevice } from '../utils/Utils';
import { AssetDetails } from '../configs/SpApiResponse';
import { FeatureFlagConstant } from '../utils/FeatureFlagConstant';

export function addWaterMark(videoPlayer: { el: () => any }, logoPayload: any, tvshowId: string) {
  const consumptionPageType = getConsumptionPageType();
  const logoPosition = getLogoPosition(logoPayload, consumptionPageType, tvshowId) || { lr: 'left', tb: 'top' };
  const watermarkContainer = document.createElement('div');
  watermarkContainer.setAttribute('class', `watermarkContainer ${logoPosition?.lr} ${logoPosition?.tb}`);
  const zee5Logo = document.createElement('img');
  zee5Logo.setAttribute('class', 'watermarkIcon');
  zee5Logo.src =
    'https://imgstg.zee5.com/image/upload/v1747132532/frontend/branding/images/version-2/logo.png';

  Object.assign(zee5Logo.style, {
    opacity: '1',
    height: isMobileDevice() ? '30px' : '35px'
  });

  watermarkContainer.appendChild(zee5Logo);

  const videoEL = videoPlayer && videoPlayer.el();
  if (logoPosition.enabled) {
    videoEL && videoEL.appendChild(watermarkContainer);
  }
}

export function fetchConcurrentUsers(
  playableData: AssetDetails,
  playerConfig: any,
  logoPayload: any
) {
    const { payload } = playerConfig?.getFeatureFlagConfig(
    FeatureFlagConstant.CONFIG_SPORTS
  );
  if (!payload.enable_concurrent_user_api) {
    addConcurrentUsers(null, logoPayload);
    return;
  }
  const showInfo = {
    showId: playableData.id,
    country: playerConfig.country
  };
  playerConfig.getConcurrentUsers(showInfo).then((data: { formatted: any }) => {
    const liveUsers = document.querySelector('.liveUsers');
    if (liveUsers && data && data.formatted) {
      updateConcurrentUsers(data.formatted, logoPayload);
    } else {
      addConcurrentUsers(data.formatted, logoPayload);
    }
  });
}

function addConcurrentUsers(concurrentUsers: any, logoPayload: any) {
  const liveUsersContainer = document.querySelector('.liveUsersContainer');
  const watermarkContainer = document.querySelector('.watermarkContainer');
  if (!liveUsersContainer) {
    const liveUsersContainer = document.createElement('div');
    liveUsersContainer.setAttribute('class', 'liveUsersContainer');

    const liveUsers = document.createElement('span');
    liveUsers.setAttribute('class', 'liveUsers');

    if (concurrentUsers && concurrentUsers.trim() !== '') {
      const visibilityOnImg = document.createElement('img');
      visibilityOnImg.setAttribute('class', 'visibilityImg');
      visibilityOnImg.src =
        'https://stcf-prod.zee5.com/prod/zee5Videojs/resources/images/VisibilityOn.svg';
      liveUsersContainer.append(visibilityOnImg);
      liveUsers.innerHTML = `${concurrentUsers} ${logoPayload.textWithConcurrentUsers || 'VIEWS'}`;
    } else {
      liveUsers.innerHTML = `${logoPayload.textWithoutConcurrentUsers || 'LIVE'}`;
    }
    liveUsersContainer.append(liveUsers);
    if (watermarkContainer) {
      watermarkContainer.appendChild(liveUsersContainer);
    }
  }
}

function updateConcurrentUsers(concurrentUsers: any, logoPayload: any) {
  const liveUsers = document.querySelector('.liveUsers');
  if (liveUsers) {
    liveUsers.innerHTML = `${concurrentUsers} ${logoPayload.textWithConcurrentUsers || 'VIEWS'}`;
  }
}

export const addUserWaterMark = (
  videoPlayer: { el: () => any },
  userWaterMarkConfig: any
) => {
  const MIN_INTERVAL_MS = (userWaterMarkConfig?.user_watermark_min_interval || 180) * 1000;
  const MAX_INTERVAL_MS = (userWaterMarkConfig?.user_watermark_max_interval || 300) * 1000;
  const VISIBLE_DURATION_MS = (userWaterMarkConfig?.user_watermark_visibility_duration || 3) * 1000;
  const getRandomInterval = () =>
    Math.floor(Math.random() * (MAX_INTERVAL_MS - MIN_INTERVAL_MS + 1)) +
    MIN_INTERVAL_MS;

  function showWatermark() {
    const videoEL = videoPlayer && videoPlayer.el?.();
    if (!videoEL) {
      return;
    }
    const userId = getUserId('logged') || '';

    const watermark = document.createElement('div');
    const randomClassNumber = Math.floor(Math.random() * 1000000000);
    watermark.className = `watermark-${randomClassNumber}`;
    watermark.innerText = processEncryption(userId);

    Object.assign(watermark.style, {
      position: 'absolute',
      color: 'rgba(255, 255, 255, 0.4)',
      fontSize: isMobileDevice() ? '10px' : '18px',
      fontWeight: 800,
      pointerEvents: 'none',
      zIndex: 9999
    });

    if (window?.getComputedStyle(videoEL)?.position === 'static') {
      videoEL.style.position = 'relative';
    }

    videoEL?.appendChild(watermark);
    const rect = videoEL?.getBoundingClientRect();
    const containerWidth = rect?.width || 0;
    const containerHeight = rect?.height || 0;
    const watermarkWidth = watermark?.offsetWidth || 0;
    const watermarkHeight = watermark?.offsetHeight || 0;

    const maxX = Math.max(0, containerWidth - watermarkWidth);
    const maxY = Math.max(0, containerHeight - watermarkHeight);

    const allowedMinPercent = 10;
    const allowedMaxPercent = 90;

    const maxLeftPercentBySize = containerWidth > 0 ? (maxX / containerWidth) * 100 : 0;
    const maxTopPercentBySize = containerHeight > 0 ? (maxY / containerHeight) * 100 : 0;

    const leftUpper = Math.min(allowedMaxPercent, maxLeftPercentBySize);
    const topUpper = Math.min(allowedMaxPercent, maxTopPercentBySize);
    const leftLower = Math.min(allowedMinPercent, leftUpper);
    const topLower = Math.min(allowedMinPercent, topUpper);

    const leftPercent = leftLower + Math.random() * (leftUpper - leftLower);
    const topPercent = topLower + Math.random() * (topUpper - topLower);

    watermark.style.left = `${leftPercent}%`;
    watermark.style.top = `${topPercent}%`;
    window.setTimeout(() => {
      watermark?.remove();
    }, VISIBLE_DURATION_MS);
  }

  const scheduleWatermark = () => {
    showWatermark();
    window.setTimeout(scheduleWatermark, getRandomInterval());
  };

  window.setTimeout(scheduleWatermark, getRandomInterval());
};

function processEncryption(userId: string | null): string {
  if (!userId) {
    return '';
  }
  const finalEncryptedToken = getStableShortCode(userId);
  return finalEncryptedToken;
}